import { connect } from 'react-redux'
import { EventHome } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { records, mount } = state.eventCard
  const { language } = state.user
  var eventId, isMounted

  eventId = ownProps.match.params.eventId
  isMounted = records.some((rc) => Boolean(rc.id === eventId)) && mount
  return ({
    width,
    isMounted,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventHome)


// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventHome.js